// @flow
import React, { Component, Fragment } from 'react';
import MainMobileHeadContainer from 'containers/main/MainMobileHeadContainer';
import MainHeadContainer from 'containers/main/MainHeadContainer';
import MainMobileFooter from 'components/main/MainMobileFooter';
import ProductViewer from 'containers/product/ProductViewer';
import { type Match } from 'react-router-dom';
import ProductCommentsContainer from 'containers/product/ProductCommentsContainer';
import ProductTemplate from "components/product/ProductTemplate";
import PageTemplate from "components/base/PageTemplate";

type Props = {
  match: Match,
};

class Product extends Component<Props> {
  componentWillUnmount() {
    // if (window.ChannelIO) {
    //   window.ChannelIO('boot', { pluginKey: '640462e2-2b19-4b18-92e4-bea6ed17cf2e' });
    // }
  }

  render() {
    const { username, urlSlug } = this.props.match.params;

    return (
      <PageTemplate>
        <header>
          <MainHeadContainer />
          <MainMobileHeadContainer />
        </header>
        <ProductTemplate>
          <ProductViewer username={username} urlSlug={decodeURI(urlSlug || '')} />
          <ProductCommentsContainer />
        </ProductTemplate>
        <MainMobileFooter />
      </PageTemplate>
    );
  }
}

export default Product;



// WEBPACK FOOTER //
// ./src/pages/Product.js